<section class="file-container">
  @if (uploadFileList.length === 0) {
    <label for="input--file" class="input-file-wrapper">
      <input (change)="onFileChange($event)" type="file" id="input--file" name="input--file" multiple />
      <fa-icon [icon]="faCloudArrowUp"></fa-icon>
      <p class="text--sm text--semibold">Choisir un fichier</p>
      <aside class="text--sm text--regular">ou déposer un fichier</aside>
    </label>
  }
  <section class="upload-list">
    @for (file of uploadFileList; track i; let i = $index) {
      <section class="upload-list--item" [class.upload-list--item--error]="file.error">
        <fa-icon [icon]="faFile"></fa-icon>
        <section class="file-info">
          <p class="text--sm text--semibold primary-500">{{ file.name }}</p>
          <aside class="text--xs text--regular primary-500">
            {{ file.size }}
          </aside>
        </section>
        <section class="progress-bar"></section>
        <section class="progress-percent"></section>
        <fa-icon (click)="deleteFile(i)" [icon]="faTrashCan"></fa-icon>
      </section>
    }
  </section>
</section>
